import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {TopNavbarComponent} from './components/layout/top-navbar/top-navbar.component';
import {LeftNavbarComponent} from './components/layout/left-navbar/left-navbar.component';
import {NgIf, NgTemplateOutlet} from '@angular/common';
import {LoaderComponent} from './components/layout/loader/loader.component';
import {SnackbarComponent} from './components/layout/snackbar/snackbar.component';
import {DialogModalComponent} from './components/layout/dialog-modal/dialog-modal.component';
import {AuthService} from './services/auth/auth.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TopNavbarComponent, LeftNavbarComponent, NgTemplateOutlet, NgIf, LoaderComponent, SnackbarComponent, DialogModalComponent, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  constructor(
    private translate: TranslateService,
    private auth: AuthService,
    private router: Router,
  ) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    });
  }

  isLogged(): boolean {
    return this.auth.isLogged();
  }
}
